import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=2da95c89&scoped=true&lang=html&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=2da95c89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da95c89",
  null
  
)

export default component.exports